// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"n4-z","dimensionLabel":"o4-z","styleChooserControlWrapper":"p4-z","styleChooserControl":"q4-z","disabled":"r4-z","giftCard":"s4-z","styleChooserText":"t4-z"};